import { BorderSketchType } from '@src/slide/domain/ui-model/element-modeles/property/border/constants';

export const segmentType = {
    MoveTo: 'M',
    LineTo: 'L',
    CurveTo: 'C',
    QuadraticCurveTo: 'Q',
    ClosePath: 'Z',
} as const;

/**
 * 点相对直线的方向；以水平线为基准
 */
export enum PointDirection {
    UP = -1,
    DOWN = 1,
}

export const SketchRoughness = {
    [BorderSketchType.CURVED]: 4,
    [BorderSketchType.FREEHAND]: 5,
    [BorderSketchType.SCRIBBLE]: 4,
};

export const SketchBowing = {
    [BorderSketchType.CURVED]: 7,
    [BorderSketchType.FREEHAND]: 1,
    [BorderSketchType.SCRIBBLE]: 1,
};

export const SketchRoughnessOffset = {
    [BorderSketchType.CURVED]: 5,
    [BorderSketchType.FREEHAND]: 3,
    [BorderSketchType.SCRIBBLE]: 4,
};
